export default {
	ACADEMIC_HIGHSCHOOL_CONTINUE_ANYWAY: 'academic_highschool - continue_anyway',
	ACADEMIC_HIGHSCHOOL_FIND_BACHELORS: 'academic_highschool - find_bachelor',
	QUESTION_SKIPPED: 'question - skipped',
};
